import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

export default function Eight() {
  const options = {
    loop: true,
    margin: 10,
    nav: false,
    responsive: {
      0: {
        items: 2
      },
      600: {
        items: 4
      },
      1000: {
        items: 6
      }
    }
  };

  const clients = [
    { id: 1, imgSrc: '/assets/img/logos/accor.png', alt: 'Client 1' },
    { id: 2, imgSrc: '/assets/img/logos/anemon.png', alt: 'Client 2' },
    { id: 3, imgSrc: '/assets/img/logos/divan.png', alt: 'Client 3' },
    { id: 4, imgSrc: '/assets/img/logos/dedeman.png', alt: 'Client 4' },
    { id: 5, imgSrc: '/assets/img/logos/wyndham.png', alt: 'Client 5' },
    { id: 6, imgSrc: '/assets/img/logos/hilton.png', alt: 'Client 6' },
  ];

  return (
    <section className="section client-section">
      <div className="container">
        <div className="row">
          <div className="col-xl-12 wow fadeInUp text-center" data-wow-delay="0.2s">
            <h6 className="fs-16 fw-medium mb-4">Trusted By 40+ Clients Around the Globe</h6>
          </div>
        </div>
        <OwlCarousel className="client-slider" {...options}>
          {clients.map(client => (
            <div 
              key={client.id} 
              className="client-img" 
              style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100%' 
              }}
            >
              <img 
                src={client.imgSrc}
                onContextMenu={(e) => e.preventDefault()}
                onDragStart={(e) => e.preventDefault()} 
                alt={client.alt} 
                style={{ 
                  padding: '30px', 
                  maxWidth: '100%', 
                  maxHeight: '100%' 
                }} 
              />
            </div>
          ))}
      </OwlCarousel>

      </div>
    </section>
  );
}
